import api from '../../utils/axios';

export const profileService = {
  // Agent Profile
  getProfile: async () => {
    const response = await api.get('/agent/profile');
    return response.data;
  },

  updateProfile: async (userId, payload) => {
    const response = await api.put(`/auth/${userId}`, payload);
    return response.data;
  },

  uploadLogo: async (formData) => {
    const response = await api.post('/upload/single', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  // Password & OTP
  sendOtp: async (method, payload) => {
    const endpoint = method === 'email' ? '/auth/sendOtp' : '/auth/sendSmsOtp';
    const response = await api.post(endpoint, payload);
    return response.data;
  },

  verifyOtp: async (method, payload) => {
    const endpoint = method === 'email' ? '/auth/verifyOtp' : '/auth/verifySmsOtp';
    const response = await api.post(endpoint, payload);
    return response.data;
  },

  resetPassword: async (payload) => {
    const response = await api.post('/auth/reset-password', payload);
    return response.data;
  },

  // Subscription Plans & Operations
  getAvailablePlans: async () => {
    const response = await api.get('/agent/available-plans');
    return response.data;
  },

  createCheckout: async (planId, billingInterval = 'month', options = {}) => {
    const response = await api.post('/agent/subscribe', {
      plan_id: planId,
      billing_interval: billingInterval,
      ...options
    });
    return response.data;
  },

  verifyPayment: async (data) => {
    const response = await api.post('/agent/verify-subscription', data);
    return response.data;
  },

  createSubscriptionRequest: async (payload) => {
    const response = await api.post('/agent/subscription-request', payload);
    return response.data;
  },

  createUpdatePaymentMethodSession: async () => {
    const response = await api.post('/agent/create-payment-method-update-session');
    return response.data;
  },

  verifyUpdatePaymentMethod: async (data) => {
    const response = await api.post('/agent/verify-payment-method-update', data);
    return response.data;
  }
};

export default profileService;
